import { useState, useEffect } from 'react'
import type { Session } from '@supabase/supabase-js'
import { initAnalytics, identifyUser, trackPage, resetAnalytics, optOut, trackEvent } from '../lib/analytics'

const CONSENT_KEY = 'bc_cookie_consent'

export function useCookieConsent(session: Session | null, pathname: string): {
  cookieConsent: 'accepted' | 'rejected' | null
  handleCookieAccept: () => void
  handleCookieReject: () => void
} {
  const [cookieConsent, setCookieConsent] = useState<'accepted' | 'rejected' | null>(
    () => localStorage.getItem(CONSENT_KEY) as 'accepted' | 'rejected' | null
  )

  useEffect(() => {
    if (cookieConsent === 'accepted') initAnalytics()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (cookieConsent === 'accepted') trackPage(pathname)
  }, [pathname, cookieConsent])

  useEffect(() => {
    if (session && cookieConsent === 'accepted') {
      identifyUser(session.user.id, session.user.email)
    }
    if (!session) resetAnalytics()
  }, [session, cookieConsent])

  function handleCookieAccept() {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    setCookieConsent('accepted')
    initAnalytics()
    if (session) identifyUser(session.user.id, session.user.email)
    trackPage(pathname)
    trackEvent('cookie_consent_accepted')
  }

  function handleCookieReject() {
    localStorage.setItem(CONSENT_KEY, 'rejected')
    setCookieConsent('rejected')
    optOut()
    trackEvent('cookie_consent_rejected')
  }

  return { cookieConsent, handleCookieAccept, handleCookieReject }
}
